import store, { subscribe } from 'shared/store'
import { EXPANDER_INIT } from 'shared/store/ducks/events'
import { actionNames } from 'shared/store/ducks/userSession'
import expander from 'views/assets/scripts/expander'
import floatingLabel from 'views/assets/scripts/floatingLabel'
import formControlValidation from 'views/assets/scripts/formValidation/formControlValidation'
import modal from 'views/assets/scripts/modal'
import { NEWSLETTER_FORM_ID } from 'views/consts'
import loadCatalogs from 'views/containers/browser/utils/loadCatalogs'

const loadNewsletter = async () => {
  const container = document.getElementById(NEWSLETTER_FORM_ID)

  const {
    publicConfig: { locale },
  } = store.getPublicRuntimeConfig()
  const i18n = await loadCatalogs(locale)

  const renderNewsletterForm = await import(
    /* webpackChunkName: "NewsletterFormContainerWithRender" */
    `./NewsletterFormContainerWithRender`
  )

  renderNewsletterForm.default({
    container,
    i18n,
  })

  floatingLabel()
  formControlValidation()
  modal()

  subscribe.after(EXPANDER_INIT, () => {
    expander()
  })

  if (window?.dataLayer) {
    window.dataLayer.push({ 'event': 'newsletterSubscribe' })
  }
}

export default async () => {
  subscribe.after.once(actionNames.setUserSession, loadNewsletter)
}
